/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".colhidden[_ngcontent-%COMP%] {\n  display: none; }\n\n.bordernodata[_ngcontent-%COMP%] {\n  border-top: none;\n  line-height: 35px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/req-document/req-document.component.scss.shim.ngstyle.js.pre-build-optimizer.js